import Image from "next/image";
import Link from "next/link";
import {
  MOBILE_TACTSUIT_SUBMENUS,
  SubMenu,
} from "@/v2-components/global-navigation-bar/_const/navigation-menus";
import { useTrans } from "@/utils/useTrans";

// Product Card Component
interface ProductCardProps {
  product: SubMenu;
}

function ProductCard({ product }: ProductCardProps) {
  return (
    <Link
      href={product.href}
      key={product.slug}
      className="group inline-flex h-48 flex-1 flex-col items-center justify-center gap-3 px-3"
    >
      <div className="relative h-20 w-20">
        <Image
          className="absolute left-0 top-0 h-20 w-20 transition-transform duration-300 group-hover:scale-110"
          src={product.imageSrc ?? "/images/tactsuit/default.png"}
          alt={`Image of ${product.name}`}
          width={80}
          height={80}
        />
      </div>
      <p className="whitespace-nowrap text-center text-base">{product.name}</p>
    </Link>
  );
}

// Product Grid Component
function ProductGrid() {
  return (
    <div className="grid grid-cols-2 content-start items-start justify-start self-stretch smd:grid-cols-4 laptop:inline-flex">
      {MOBILE_TACTSUIT_SUBMENUS.map((product, index) => (
        <ProductCard key={index} product={product} />
      ))}
    </div>
  );
}

export default function ProductsSection() {
  const { t } = useTrans(["about"]);
  return (
    <div className="flex flex-col items-center justify-center gap-8 self-stretch">
      <div className="justify-start self-stretch text-center text-4xl">
        {t(`Our Products`)}
      </div>
      <ProductGrid />
    </div>
  );
}
